<script>
  export let tooltip = false; // prevent blank tooltips
</script>

<div data-tooltip={tooltip}>
  <slot />
</div>

<style src="./tooltip.scss"></style>
